import { useInstance } from '@meraki-internal/react-dependency-injection';
import { SocketState } from './SocketState';
import { useEffect } from 'react';

export const WebSocketListener: React.FC = () => {
    const socketState = useInstance(SocketState);

    useEffect(() => {
        socketState.init();
        return () => {
            socketState.dispose();
        };
    }, [socketState]);
    return null;
};
